<style lang="scss" scoped> 
    .query-warp{
        width: 100%;
        padding-bottom: 25px;
    }
    .base-warp{
        width: 100%;height: 100%;
        overflow: hidden;overflow-y: auto;
    }
    .page-warp{
        text-align: right;position: relative;
    }
</style>
<template>
    <div>
        <Divider orientation="center">子账户管理</Divider>
        
        <div class="query-warp">
            <Button :loading="loading" @click="addChildUser">新增子账号</Button>
        </div>
        <div class="base-warp">
            <Table :loading="loading" size="small" :height="420" border :columns="columns" :data="list" >
                <template #lastLoginDateTime="{ row }">
                    <span>{{ row.lastLoginLog ? row.lastLoginLog.loginDateTime : '尚未登陆'}}</span>
                </template>
                <template #charNum="{ row }">
                    <a @click="distribution(row.userId)">
                        {{row.memberAccount.usableCharNum ? row.memberAccount.usableCharNum : 0}}
                    </a>
                </template>
                <template #enabled="{ row }">
                    <a v-if="row.enabled == 1" style="color:#19be6b" @click="changeEnabled(row)">启用</a>
                    <a v-else style="color:#ed4014" @click="changeEnabled(row)">禁用</a>
                </template> 
                <template #option="{ row }">
                    <a style="padding-right:5px" @click="distribution(row.userId)">分配</a>
                    <a style="padding-right:5px" @click="updateChildUser(row.userId)">修改</a>
                    <a @click="resetPassword(row)">重置</a>
                </template>
            </Table>
        </div>
        <div class="page-warp">
            <Page style="margin-top:25px" show-total :total="page.total" :page-size="page.size" v-model="page.num" @on-change="pageChange"/>
        </div>
        <ChildUserDrawer ref="ChildUserDrawerRef" @on-success="childUserSaveSucc"/>
        <ChildUserDistributionDrawer ref="ChildUserDistributionDrawerRef" @on-success="childUserSaveSucc"/>
    </div>
</template>

<script>
    import ChildUserDrawer from "@/components/ChildUserDrawer"
    import ChildUserDistributionDrawer from "@/components/ChildUserDistributionDrawer"
    import userService from "@/service/user/index.js"
    export default {
        components:{ChildUserDrawer,ChildUserDistributionDrawer},
        name: 'UserCenterChild',
        data() {
            return {
                loading : false,
                columns: [
                    {type: 'index',"title" : '序号',width:75,fixed:"left"},
                    {title: '账号',key: 'account'},
                    {title: '昵称',key: 'nickname'},
                    {title: '最后登陆时间',slot: 'lastLoginDateTime',width:155,},
                    {title: '字符数量',slot: 'charNum'},
                    {title: '是否启用',slot: 'enabled',width:85},
                    {title : '操作',width:150,fixed:"right",slot:"option"},

                ],
                page: {
                    size : 10,
                    num : 1,
                    total: 0,
                },
                list : []
            }
        },
        mounted(){
            this.init();
        },
        methods:{
            init(){
                this.loadData();
            },
            async loadData(){
                let params = {
                    pageSize : this.page.size,
                    pageNum : this.page.num
                }
                this.loading = true;
                let result = await userService.page(params);
                this.loading = false;
                this.page.total = result.total;
                this.list = result.rows;
            },
            pageChange(){
                this.loadData();
            },
            addChildUser(){
                this.$refs.ChildUserDrawerRef.open();
            },
            distribution(userId){
                this.$refs.ChildUserDistributionDrawerRef.open(userId);
            },
            updateChildUser(userId){
                this.$refs.ChildUserDrawerRef.open(userId);
            },
          changeEnabled(row){
            let {userId,nickname,enabled} = row;
            let status = enabled == 1 ? '<span style="color:red">禁用</span>' : '<span style="color:green">启用</span>';
            let content = '您确定要 ['+status+'] 用户 ['+nickname+'] 吗?' ;
            this.$Modal.confirm({
              title: '温馨提示',
              content,
              loading:true,
              onOk: async () => {
                let e = enabled == 1 ? 0 : 1;
                let result = await userService.changeEnabled({userId,enabled : e});
                this.$Modal.remove();
                if(result){
                  this.$Message.success('成功修改['+result+']个账号');
                  this.loadData();
                }
              }
            });
          },
            resetPassword(user){
                this.$Modal.confirm({
                    title: '提示',
                    content: `<p>你确定将 <strong> ${user.nickname} </strong>的密码重置为<strong> 123456 </strong>吗</p>`,
                    onOk: async () => {
                        await userService.resetPassword(user.userId);
                        this.$Message.success('重置成功');
                    },
                });
            },
            childUserSaveSucc(){
                this.loadData();
            }
        }
    }
</script>

